export default __webpack_public_path__ + "files/9b0519e1f5fbf82b0548515994fd49d4.png";